import React, { useContext, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import PerfectScrollbar from "react-perfect-scrollbar";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import PropTypes from "prop-types";
import SupervisorAccountOutlinedIcon from "@mui/icons-material/SupervisorAccountOutlined";
import AddBusinessOutlinedIcon from "@mui/icons-material/AddBusinessOutlined";
import LocalHospitalIcon from "@mui/icons-material/LocalHospital";
import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";
import InventoryOutlinedIcon from "@mui/icons-material/InventoryOutlined";
import AccountBoxOutlinedIcon from "@mui/icons-material/AccountBoxOutlined";
import DashboardOutlinedIcon from "@mui/icons-material/DashboardOutlined";
import EventIcon from "@mui/icons-material/Event";

import { FolderCopyOutlined } from "@mui/icons-material";

import { FaUserDoctor } from "react-icons/fa6";
import { IoManSharp } from "react-icons/io5";

import { AuthContext } from "../../../context/Auth";

import {
  Box,
  Drawer,
  Hidden,
  List,
  Button,
  ListSubheader,
  Typography,
  Dialog,
  DialogActions,
  DialogContent,
  Slide,
} from "@mui/material";
import NavItem from "./NavItem";
import { RxCrossCircled } from "react-icons/rx";

const useStyles = (theme) => ({
  mobileDrawer: {
    width: 256,
    background: "linear-gradient(135deg, #48426D, #312C51)",
    position: "fixed",
  },
  desktopDrawer: {
    "& .MuiPaper-root": {
      backgroundColor: "red",
    },
    zIndex: "1",
    marginTop: "70px !important",
    top: "76px",
    width: "272px",
    height: "calc(100% - 125px)",
    margin: "5px 10px 10px 15px",
    background: "linear-gradient(135deg, #48426D, #312C51)",
    position: "fixed",
    boxShadow: "0px 0px 53px rgba(0, 0, 0, 0.25)",
    borderRadius: "10px",
    marginLeft: "13px",
  },
  logoutButton: {
    color: "#fff",
    display: "flex",
    justifyContent: "start",
    alignItems: "center",
    position: "absolute",
    bottom: "5px",
    left: "17px",
    background: "#fff",
    fontWeight: "400",
    fontSize: "13px",
  },
  dialog: {
    "& .MuiDialog-paper": {
      background: "white !important",
    },
  },
  logoutimgicon: {
    border: "1px solid white",
    background: "white",
    color: "red",
    width: "100px",
    height: "70px",
  },
});

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const NavBar = ({ onMobileClose, openMobile, tabView, setSelectedTab }) => {
  const classes = useStyles();
  const location = useLocation();
  const [isLogout, setIsLogout] = useState(false);
  const { logout } = useContext(AuthContext);

  const sections = [
    {
      items: [
        {
          title: "Dashboard",
          icon: DashboardOutlinedIcon,
          href: "/dashboard",
          tabview: "Arbitrage",
        },
        {
          title: "User Managment",
          icon: SupervisorAccountOutlinedIcon,
          items: [
            {
              title: "Doctor Management",
              icon: FaUserDoctor,
              href: "/doctorlisting",
              tabview: "Arbitrage",
            },
            {
              title: "Patient Management",
              icon: IoManSharp,
              href: "/patientlisting",
              tabview: "Arbitrage",
            },
          ],
        },
        {
          title: "Appointement Management",
          icon: InventoryOutlinedIcon,
          href: "/appointementlisting",
        },
        // {
        //   title: "Event Management",
        //   icon: EventIcon,
        //   href: "/eventlisting",
        // },
        // {
        //   title: "Marketplace Management",
        //   icon: AddBusinessOutlinedIcon,
        //   href: "/marketplacelisting",
        // },
        // {
        //   title: "Transaction Management",
        //   icon: AccountBalanceWalletOutlinedIcon,
        //   href: "/transactionListing",
        // },
        {
          title: "Content Management",
          icon: FolderCopyOutlined,
          href: "/staticContentListing",
        },
        {
          title: "My Account",
          icon: AccountBoxOutlinedIcon,
          href: "/profile",
          tabview: "Arbitrage",
        },
      ],
    },
  ];

  const renderNavItems = ({ items, pathname, depth = 0, setSelectedTab }) => (
    <List disablePadding>
      {items?.map((item) => {
        const key = item.title + depth;
        const isActive = pathname.includes(item.href);
        return item.items ? (
          <NavItem
            depth={depth}
            icon={item.icon}
            info={item.info}
            key={key}
            open={Boolean(isActive)}
            title={item.title}
            isActive={isActive}
          >
            {renderNavItems({
              depth: depth + 1,
              pathname,
              items: item.items,
              setSelectedTab,
            })}
          </NavItem>
        ) : (
          <NavItem
            depth={depth}
            href={item.href}
            icon={item.icon}
            info={item.info}
            key={key}
            title={item.title}
            setSelectedTab={(item) => setSelectedTab(item)}
            isActive={isActive}
          />
        );
      })}
    </List>
  );

  const content = (
    <Box
      height="100%"
      display="flex"
      flexDirection="column"
      alignItems={"start"}
      justifyContent={"space-between"}
      paddingBottom={"20px"}
    >
      <PerfectScrollbar options={{ suppressScrollX: true }}>
        <Box pt={2} pb={2}>
          <Box className="sideMenuBox">
            {sections.map((section, i) => (
              <List
                key={`menu${i}`}
                subheader={
                  <ListSubheader disableGutters disableSticky>
                    {section.subheader}
                  </ListSubheader>
                }
              >
                {renderNavItems({
                  items: section.items,
                  pathname: location.pathname,
                  setSelectedTab,
                })}
              </List>
            ))}
          </Box>
        </Box>
      </PerfectScrollbar>
      <Button
        onClick={() => setIsLogout(true)}
        className={classes.logoutButton}
        style={{ color: "white", textAlign: "center" }}
      >
        <ExitToAppIcon style={{ marginRight: "5px" }} />
        &nbsp; Logout
      </Button>
      {isLogout && (
        <Dialog
          maxWidth="sm"
          fullWidth
          className={classes.dialog}
          open={isLogout}
          TransitionComponent={Transition}
          keepMounted
          onClose={() => setIsLogout(false)}
        >
          <DialogContent>
            <Box className={classes.dialougTitle} align="center">
              <Box>
                <RxCrossCircled className={classes.logoutimgicon} />
              </Box>
              <Typography
                variant="h4"
                color="primary"
                style={{ marginTop: "20px", color: "black" }}
              >
                LOGOUT
              </Typography>
              <Typography
                variant="h6"
                color="primary"
                style={{ marginTop: "20px", color: "black" }}
              >
                Are you sure you want to logout?
              </Typography>
            </Box>
          </DialogContent>
          <DialogActions
            style={{ alignContent: "center", justifyContent: "center" }}
          >
            <Box mt={2} style={{ marginTop: "20px" }}>
              <Button
                className="modelbtn"
                variant="containedPrimary"
                onClick={() => setIsLogout(false)}
              >
                No
              </Button>
              &nbsp; &nbsp;
              <Button
                className="modelbtnyes"
                variant="containedPrimary"
                onClick={() => {
                  logout();
                  setIsLogout(false);
                }}
              >
                Yes
              </Button>
            </Box>
          </DialogActions>
        </Dialog>
      )}
    </Box>
  );

  return (
    <>
      <Hidden lgUp>
        <Drawer
          anchor="left"
          classes={{ paper: classes.mobileDrawer }}
          open={openMobile}
          onClose={onMobileClose}
          variant="temporary"
          sx={{
            "& .MuiPaper-root": {
              background: "linear-gradient(90deg, #48426D, #312C51)",
              color: "white", // Example text color
            },
          }}
        >
          <Box pt={2} pb={2}>
            {content}
          </Box>
        </Drawer>
      </Hidden>
      <Hidden mdDown>
        <Drawer
          anchor="left"
          classes={{ paper: classes.desktopDrawer }}
          open
          variant="persistent"
          sx={{
            "& .MuiPaper-root": {
              marginTop: "89px !important",
              background: "linear-gradient(90deg, #48426D, #312C51)",
              color: "white", // Example text color
              boxShadow: "0px 0px 53px rgba(0, 0, 0, 0.25)",
              borderRadius: "10px",
              width: "272px",
              height: "calc(100% - 125px)",
              margin: "5px 4px 10px 8px",
              position: "fixed",
            },
          }}
        >
          {content}
        </Drawer>
      </Hidden>
    </>
  );
};

NavBar.propTypes = {
  onMobileClose: PropTypes.func,
  openMobile: PropTypes.bool,
  setSelectedTab: PropTypes.func.isRequired,
};

export default NavBar;
